import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/portals/src/components/AppLayout/AppHeaderContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterLinks"] */ "/vercel/path0/apps/portals/src/components/AppLayout/FooterLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UILayout"] */ "/vercel/path0/apps/portals/src/components/AppLayout/UILayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppContextProvider"] */ "/vercel/path0/apps/portals/src/wrappers/AppContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","src"] */ "/vercel/path0/packages/@wolfejs/assets/bbb.png");
;
import(/* webpackMode: "eager", webpackExports: ["default","src"] */ "/vercel/path0/packages/@wolfejs/assets/pci_compliant_badge.png");
;
import(/* webpackMode: "eager", webpackExports: ["UploadIcon","WolfeMerchantSolutionsIcon","Template","ReceiptDollar","Bank","Reports","Cog","Support"] */ "/vercel/path0/packages/@wolfejs/icons/IconMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppNav"] */ "/vercel/path0/packages/@wolfejs/ms-ui/AppNav/AppNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ui/Card/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/packages/@wolfejs/ui/ErrorBoundary/ErrorBoundary.tsx");
